import errorApi from "../../api/errorApi";
// import { getBaseUrl } from "../../../components/common/getEnv";
import { decrypt } from "../../secure";
// import { getXApiKeyByEnv } from "../../constants";
import debug from "../../debug";
import { DATALAKE_TRACKER_URL } from "../../constants/env-resolver";

export const getXApiKeyByEnv = () => {
  return decrypt(null, process.env.REACT_APP_ENCRYPTED_X_API_KEY, true).replace(
    /"|'|`/g,
    ``
  );
};

const withLoginDatalake = async ({
  customerId,
  APIPayloadToPost,
  Authorization,
  successFn = res => {
    debug("WATCH", `Response: `, res);
  },
  errorFn = err => {
    debug("ERROR", `Error: `, err);
  },
  finallyFn = () => {
    debug("WATCH", `Finally: `);
  },
}) => {
  await errorApi(
    // `${getBaseUrl()}dashboardmenus/datalake/tracking`,
    `${DATALAKE_TRACKER_URL}`,
    APIPayloadToPost,
    "POST",
    {
      Authorization: Authorization,
      "x-api-key": getXApiKeyByEnv(),
    }
  )
    .then(res => {
      successFn(decrypt(customerId, res.data.response));
    })
    .catch(err => {
      debug("ERROR", err);
      errorFn(err);
    })
    .finally(() => {
      finallyFn();
    });
};

export default withLoginDatalake;
